import './style.styl'
import { bp, l, mm, onDomReady, pauseVideos, playVideos, sel, stResizeObserver, vh } from './utils'
import { footer, navbarOld, navbar } from './general'
import Home from './home'
import Approach from './approach'
import About from './about'
import Cases from './cases'
import Work from './work'
import WorkItem from './work-item'
import Insights from './insights'
import Insight from './insight'
import Contact from './contact'
import Chat from './pages/chat/chat'
import Author from './author'
// import FsCC from './fscc'

import insights from './comps/insights'

import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { lenis } from './lenis'
// import PullToRefresh from 'pulltorefreshjs'
import barba from '@barba/core'
import { restartWebflow } from '@finsweet/ts-utils'

pauseVideos()

let dataPage = sel('.main-wrapper')?.dataset.barbaNamespace || sel('.page-wrapper')?.dataset.page || sel('body')?.dataset.page
const ctaSec$ = sel('.cta-sec')
const footer$ = sel('.footer')

const pageOverlay$ = document.querySelector('.navbar__page-overlay')
pageOverlay$.style.transition = 'background-color 1s ease'
const pageDim$ = document.querySelector('.navbar__page-dim')
const { navbarHeight } = navbar(dataPage)
const isTouch = ScrollTrigger.isTouch === 1 // 2 (hybrid) may be triggered on pc
const screenWidth = window.screen.width
const isTouchScreen = screenWidth <= 991
const realScreenWidth = screenWidth * window.devicePixelRatio
const screenHeight = window.screen.height
const realScreenHeight = screenHeight * window.devicePixelRatio
const screenRatio = screenWidth / screenHeight

const pageOverlayHeight = screenHeight - navbarHeight + 1

stResizeObserver()

gsap.registerPlugin(ScrollTrigger)
gsap.defaults({ ease: 'none' })

let pageCtx, insightsCtx, footerCtx
let nextContainer
const views = [
  {
    namespace: 'home',
    afterEnter() {
      pageInit(Home)
    },
  },
  {
    namespace: 'work',
    afterEnter() {
      pageInit(Work, [isTouchScreen])
    },
  },
  {
    namespace: 'approach',
    afterEnter() {
      pageInit(Approach, [isTouch])
    },
  },
  {
    namespace: 'about',
    afterEnter() {
      pageInit(About)
    },
  },
  {
    namespace: 'cases',
    afterEnter() {
      pageInit(Cases)
    },
  },
  {
    namespace: 'insights',
    async afterEnter() {
      await pageInit(Insights)
    },
  },
  {
    namespace: 'insight',
    afterEnter() {
      pageInit(Insight)
    },
  },
  {
    namespace: 'contact',
    async afterEnter() {
      await pageInit(Contact)
    },
  },
  {
    namespace: 'work-item',
    afterEnter() {
      pageInit(WorkItem)
    },
  },
  {
    namespace: 'cookie1',
    afterEnter() {
      pageInit(Cookie1)
    },
  },
  {
    namespace: 'chat',
    afterEnter() {
      pageInit(Chat)
      // Chat()
    },
  },
  {
    namespace: 'author',
    afterEnter() {
      // pageInit(Author, [], false)
      pageInit(Author)
    },
  },
]
history.scrollRestoration = 'manual'
barba.init({
  // sync: true,
  // cacheIgnore: true,
  transitions: [
    {
      sync: true,
      async leave(data) {
        const next = data.next.container
        next.classList.add('barba-fixed')
        gsap.set(next, { autoAlpha: 0 })
        await gsap
          .timeline({ defaults: { ease: 'power2.in', duration: 1 } })
          .to(
            pageOverlay$,
            {
              height: !isTouchScreen && pageOverlayHeight,
              onComplete() {
                // gsap.set(next, { position: 'relative' })
                // next.classList.remove('barba-fixed')
                // gsap.to(next, { autoAlpha: 1 })
              },
            },
            0
          )
          .to(pageDim$, { autoAlpha: !isTouchScreen && 0.5 }, 0)
          .to(
            [data.current.container, ctaSec$, footer$],
            {
              opacity: isTouch && 0,
              y: !isTouchScreen && 120,
              filter: !isTouchScreen && 'blur(10px)',
              onComplete() {
                const targetScroll = data.trigger === 'back' && data.current.scrollPos ? data.current.scrollPos : 0

                lenis.scrollTo(targetScroll, {
                  immediate: true,
                })
                gsap.set(pageOverlay$, { autoAlpha: 1, height: 0 })
                gsap.set(pageDim$, { autoAlpha: 0 })
                gsap.set([data.current.container, ctaSec$, footer$], { opacity: 1, y: 0, filter: 'none' })
                // to prevent fsAttributes.init fire too soon
                data.next.container.classList.remove('barba-fixed')
                // revert fires immediately in barba hooks (and hooks.enter stops pageInit)
                pageCtx?.revert()
                // offset wait for the custom pageInit to finish
                setTimeout(() => {
                  document.body.classList.remove('barba-transition')
                }, 1000)
              },
            },
            0
          )
      },
      enter(data) {
        // await gsap.timeline({ defaults: { ease: 'power2.out', duration: 1 } }).to(
        //   data.next.container,
        //   {
        //     // autoAlpha: 1,
        //     onComplete() {},
        //   },
        //   0
        // )
      },

      once(data) {
        footerCtx = footer()
        nextContainer = data.next.container
      },
    },
  ],
  views: views,
})
let barbaFirstLoad = true
const knownNamespaces = views.map((view) => view.namespace)
barba.hooks.afterEnter(async (data) => {
  // console.log('hook afterEnter', data)
  const ns = data?.next.namespace || ''
  if (!knownNamespaces.includes(ns)) {
    // unknown page, default fade in
    gsap.from(data.next.container, { y: 30, ease: 'power4.out', duration: 1 })
    gsap.to(data.next.container, { autoAlpha: 1 })
    pageInit()
  } else {
    // known page, custom gsap init
    gsap.set(data.next.container, { autoAlpha: 1 })
  }
  // window.Webflow && Webflow.destroy()
  // window.Webflow && Webflow.ready()
  window.Webflow && Webflow.require('tabs').redraw()

  mm.add(bp.tabDown, () => {
    // console.log('mm tabDown')
    pageCtx && scrollTo(0, 0)
  })

  // $(next.container)
  //   .find(`.w-tab-link`)
  //   .each((_, el) => {
  //     el.dataset.saved = el.getAttribute('href') // store original hash
  //     el.setAttribute('href', '#') // spy will now skip it
  //   })
  //
  // // 2 ▸ normal Webflow boot for the swapped-in page
  // Webflow.ready() // rebuilds all core modules
  // Webflow.require('tabs').redraw() // your existing fix
  //
  // // 3 ▸ put the hashes back so Tabs keeps keyboard support
  // $(next.container)
  //   .find(`.w-tab-link`)
  //   .each((_, el) => {
  //     el.setAttribute('href', el.dataset.saved)
  //   })
})
barba.hooks.before((data) => {
  // console.log('hook before')
  data.current.scrollPos = window.pageYOffset || window.scrollY
})
barba.hooks.beforeLeave((data) => {
  // console.log('hook beforeLeave', data)

  dataPage = data.next.namespace
  barbaFirstLoad = false
  if (!isTouch) document.body.classList.add('barba-transition')
})
barba.hooks.beforeEnter((data) => {
  // console.log('hook beforeEnter')
  nextContainer = data.next.container
  insightsCtx?.revert()
})

async function pageInit(func, args = [], insightInit = true) {
  if (pageCtx && fsAttributes) {
    // have to be timer offset (no idea) and in this order (no idea)
    setTimeout(() => {
      // in this particular order because finsweet voodoo
      window.fsAttributes.linkblockedit?.destroy()
      window.fsAttributes.linkblockedit?.init()
      window.fsAttributes.cmsload?.destroy()
      window.fsAttributes.cmsload?.init()
      window.fsAttributes.cmsfilter?.destroy()
      window.fsAttributes.cmsfilter?.init()
      window.fsAttributes.toc?.init()
      window.fsAttributes.socialshare?.destroy()
      window.fsAttributes.socialshare?.init()
    }, 100)
  }
  window.Webflow && Webflow.ready()
  window.Webflow && Webflow.require('tabs').redraw()
  if (func) pageCtx = await func(nextContainer, ...args)
  if (insightInit) insightsCtx = insights(nextContainer, isTouchScreen, isTouch)

  playVideos()

  // since the tabs are managed separately now, this is to mostly add the underline for hrefs
  if (pageCtx) {
    insightTabsReinit()
    // window.Webflow ||= []
    // Webflow.push(() => {
    //   Webflow.ready()
    // })
    // try {
    //   window.Webflow.ready()
    // } catch (e) {
    //   console.warn('Webflow ready failed', e)
    //   setTimeout(() => {
    //     window.Webflow.ready()
    //   }, 1000)
    // }
  }
  // fixes offset on page refresh
  ScrollTrigger.refresh()
}
// to prevent refresh on same page, considering barbajs
function hrefHandler(e) {
  const link = e.target.closest('a')

  if (!link || link.href.endsWith('#') || link.classList.contains('.w-tab-link')) return
  if (link.href === window.location.href) {
    e.preventDefault()
  }
}

document.addEventListener('click', hrefHandler)

if (isTouch) {
  const ipad7GenHeight = [2420, 2752]
  const isIpad7GenRatio = screenRatio === 0.75
  // if ipad pro 7th gen and chrome
  if (isIpad7GenRatio && ipad7GenHeight.includes(realScreenHeight) && navigator.userAgent.includes('CriOS')) {
  } else {
    lenis.destroy()
  }
} else {
  lenisInit()
}
function lenisInit() {
  lenis.on('scroll', ScrollTrigger.update)
  gsap.ticker.add((time) => {
    lenis.raf(time * 1000)
  })
  gsap.ticker.lagSmoothing(0)
}

function insightTabsReinit() {
  // webflow tabs reinit, to keep the active class on scroll
  // window.Webflow ||= []
  // Webflow.push(() => {
  //   // window.Webflow.require('tabs').redraw()
  //   window.Webflow.require('tabs').redraw()
  // })
  // try {
  //   window.Webflow.require('tabs').redraw()
  // } catch (e) {
  //   console.warn('Webflow tabs reinit failed', e)
  //   setTimeout(() => {
  //     window.Webflow.require('tabs').redraw()
  //   }, 1000)
  // }

  // trim and reinit tabs if found empty panes
  setTimeout(() => {
    const panes$ = sel('.insight__panes')
    const tabs$ = sel('.insight__tabs')
    if (!panes$) return
    const pane$a = panes$.querySelectorAll('.w-tab-pane')
    // console.log('tabs$', tabs$, 'tabItems$a', tabItems$a.length)
    if (!pane$a.length) return
    // console.log('tabs$', tabs$)
    let removed = false
    pane$a.forEach((pane) => {
      const hasEmptyCms = pane.querySelector('.w-dyn-empty')
      const hasEmptyRt = pane.querySelector('.insight-rt__meta__rt.w-dyn-bind-empty')
      // console.log('hasEmptyRt', hasEmptyRt)
      if (hasEmptyCms || hasEmptyRt) {
        const paneId = pane.id
        const linkedTab$ = sel(`[aria-controls="${paneId}"]`)
        // console.log('Empty tab found:', paneId, linkedTab$)
        pane.remove()
        // tabs reinit and Author webflow ix restart, never again!
        linkedTab$?.remove()
        removed = true
      } else {
        // Clone the element to remove all event listeners (fixes toggling w--current on scroll)
        const _linkedTab$ = sel(`[aria-controls="${pane.id}"]`)
        const clonedTab$ = _linkedTab$.cloneNode(true)
        _linkedTab$.parentNode.replaceChild(clonedTab$, _linkedTab$)
        const linkedTab$ = sel(`[aria-controls="${pane.id}"]`)
        linkedTab$.addEventListener('click', (e) => {
          e.preventDefault()
          console.log('Tab clicked:', linkedTab$)
          if (linkedTab$.classList.contains('w--current')) return

          panes$.querySelector(`.w--tab-active`)?.classList.remove('w--tab-active')
          panes$.querySelector(`.w-tab-pane[aria-hidden="false"]`)?.setAttribute('aria-hidden', 'true')
          tabs$.querySelector(`.w--current`)?.classList.remove('w--current')
          tabs$.querySelector(`.w-tab-link[aria-selected="true"]`)?.setAttribute('aria-selected', 'false')

          linkedTab$.classList.add('w--current')
          linkedTab$.setAttribute('aria-selected', 'true')
          const pane$ = sel(`#${pane.id}`)
          if (pane$) {
            pane$.classList.add('w--tab-active')
            pane$.setAttribute('aria-hidden', 'false')
          }
        })
      }
    })
    // if (!removed) return

    const firstTab$ = sel('.insight__tabs').firstElementChild
    // console.log('First tab after removal:', firstTab$)
    if (!firstTab$) return

    firstTab$.classList.add('w--current')
    firstTab$.setAttribute('aria-selected', 'true')
    const firstPane$ = sel('.insight__panes').firstElementChild
    if (!firstPane$) return
    firstPane$.classList.add('w--tab-active')
    firstPane$.setAttribute('aria-hidden', 'false')

    const emptyReviewer$ = sel('.insight-rt__history__item:has(a.w-dyn-bind-empty)')
    emptyReviewer$ && emptyReviewer$.remove()

    // Webflow.scroll.off()

    // const guard = new MutationObserver((muts) => {
    //   muts.forEach((m) => {
    //     if (m.type === 'attributes' && m.target.classList.contains('w--current')) {
    //       m.target.classList.remove('w--current')
    //     }
    //   })
    // })
    // guard.observe(document.querySelector('.insight-rt__meta'), { subtree: true, attributes: true, attributeFilter: ['class'] })
  }, 500)
}
